const FACETS: ReadonlyArray<readonly [string, string, number?]> = [
  ["1062,257 1092,232 816,254", "url(#auth-lilac-flow)"],
  ["1062,257 1279,412 1092,232", "#6B55F1", 0.72],
  ["816,254 721,540 833,447", "url(#auth-violet-flow)", 0.78],
  ["1119,545 1184,698 1279,412", "#8055E6", 0.74],
  ["908,720 833,447 721,540", "#6947DC", 0.7],
  ["1119,545 908,720 1184,698", "url(#auth-blue-flow)"],
  ["1062,257 816,254 833,447", "#AC6DF6", 0.72],
  ["1062,257 1119,545 1279,412", "url(#auth-rose-flow)"],
  ["1119,545 833,447 908,720", "#B779F7", 0.76],
  ["1062,257 833,447 1119,545", "url(#auth-violet-flow)"],
];

export function AuthAnimatedBackground() {
  return (
    <div className="auth-animated-background" aria-hidden="true">
      <div className="auth-animated-background__aurora auth-animated-background__aurora--one" />
      <div className="auth-animated-background__aurora auth-animated-background__aurora--two" />
      <svg
        className="auth-animated-background__canvas"
        viewBox="0 0 1600 950"
        preserveAspectRatio="xMidYMid slice"
        focusable="false"
      >
        <defs>
          <linearGradient id="auth-violet-flow" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#4438FF" stopOpacity=".93" />
            <stop offset=".45" stopColor="#914BFA" stopOpacity=".84" />
            <stop offset="1" stopColor="#EF8DFB" stopOpacity=".45" />
          </linearGradient>
          <linearGradient id="auth-lilac-flow" x1="1" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#F1D9FF" stopOpacity=".84" />
            <stop offset=".48" stopColor="#B77CF8" stopOpacity=".74" />
            <stop offset="1" stopColor="#6A56E8" stopOpacity=".35" />
          </linearGradient>
          <linearGradient id="auth-blue-flow" x1="0" y1="1" x2="1" y2="0">
            <stop offset="0" stopColor="#77A7FF" stopOpacity=".16" />
            <stop offset=".5" stopColor="#7566FF" stopOpacity=".73" />
            <stop offset="1" stopColor="#D770FF" stopOpacity=".72" />
          </linearGradient>
          <linearGradient id="auth-rose-flow" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#FFAAE8" stopOpacity=".62" />
            <stop offset="1" stopColor="#8A4BFA" stopOpacity=".54" />
          </linearGradient>
          <filter
            id="auth-soft-glow"
            x="-40%"
            y="-40%"
            width="180%"
            height="180%"
          >
            <feGaussianBlur stdDeviation="24" />
          </filter>
          <filter id="auth-grain" x="0" y="0" width="100%" height="100%">
            <feTurbulence
              type="fractalNoise"
              baseFrequency=".9"
              numOctaves="2"
              seed="7"
            />
            <feColorMatrix type="saturate" values="0" />
            <feComponentTransfer>
              <feFuncA type="table" tableValues="0 .035" />
            </feComponentTransfer>
          </filter>
        </defs>

        <g className="auth-animated-background__stream">
          <path
            d="M505-90 780-90 1280 990 1050 990Z"
            fill="url(#auth-violet-flow)"
          />
          <path
            d="M675-90 875-90 1390 990 1250 990Z"
            fill="url(#auth-lilac-flow)"
            opacity=".7"
          />
          <path
            d="M370-90 535-90 1100 990 910 990Z"
            fill="url(#auth-blue-flow)"
            opacity=".67"
          />
        </g>
        <g filter="url(#auth-soft-glow)">
          <circle cx="1010" cy="440" r="300" fill="#8F56F4" opacity=".25" />
        </g>
        <g className="auth-animated-background__icosahedron">
          {FACETS.map(([points, fill, opacity]) => (
            <polygon
              key={points}
              points={points}
              fill={fill}
              opacity={opacity}
            />
          ))}
          <g
            className="auth-animated-background__mesh"
            fill="none"
            stroke="white"
            strokeOpacity=".34"
            strokeWidth="1.2"
          >
            <path d="M1062 257 1092 232 816 254ZM1062 257 1279 412 1092 232ZM816 254 721 540 833 447ZM1119 545 1184 698 1279 412ZM908 720 833 447 721 540Z" />
            <path d="M1119 545 908 720 1184 698ZM1062 257 816 254 833 447ZM1062 257 1119 545 1279 412ZM1119 545 833 447 908 720ZM1062 257 833 447 1119 545Z" />
          </g>
        </g>
        <g className="auth-animated-background__shards">
          <polygon
            points="270,112 390,154 312,248"
            fill="#8B6AF5"
            opacity=".22"
          />
          <polygon
            points="495,180 610,236 548,338"
            fill="#B970FB"
            opacity=".34"
          />
          <polygon
            points="175,430 328,388 286,540"
            fill="#D69BFF"
            opacity=".3"
          />
          <polygon
            points="1350,180 1448,270 1322,320"
            fill="#7C62EE"
            opacity=".24"
          />
          <polygon
            points="1470,388 1578,450 1450,520"
            fill="#B779F7"
            opacity=".27"
          />
          <polygon
            points="480,670 650,734 535,820"
            fill="#E6BCFF"
            opacity=".4"
          />
          <polygon
            points="255,720 390,656 420,812"
            fill="#7566FF"
            opacity=".2"
          />
          <polygon
            points="1370,600 1490,724 1324,760"
            fill="#A866F4"
            opacity=".27"
          />
          <polygon
            points="118,820 230,780 206,906"
            fill="#C782FA"
            opacity=".22"
          />
          <polygon
            points="1450,790 1580,842 1478,924"
            fill="#6B55F1"
            opacity=".2"
          />
        </g>
        <rect
          width="1600"
          height="950"
          filter="url(#auth-grain)"
          opacity=".55"
        />
      </svg>
      <div className="auth-animated-background__vignette" />
    </div>
  );
}
